export const UserDataModel = {
  initialize,
  constrain,
};

function initialize() {
  let result = {
    firstName: "",
    lastName: "",
    dob: "",
    gender: 0,
    pregnantStatus: 0,
    race: 10,
    ethnicity: 4,
    isFirstTest: 0,
    isInGroup: 0,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: "",
    billingType: 0,
    clientCode: "",
    insName: "",
    insID: "",
    insGroup: "",
    insAddress: "",
    insCity: "",
    insState: "",
    insZip: "",
    insPhone: "",
    insSubName: "",
    insSubDOB: "",
    insRel: 0,
    creationDate: new Date(),
    noInsChecked: false,
  };
  return result;
}
function constrain() {
  let result = {
    firstName: 30,
    lastName: 40,
    addressLine1: 100,
    addressLine2: 100,
    city: 30,
    state: 2,
    zip: 5,
    email: 60,
    clientCode: 10,
    insName: 100,
    insID: 20,
    insGroup: 20,
    insAddress: 150,
    insCity: 30,
    insState: 2,
    insZip: 5,
    insSubName: 70,
  };
  return result;
}

export default UserDataModel;
